import { ApiService } from './api/api'

export default class BrandsService {
	private apiService

	constructor() {
		this.apiService = new ApiService()
	}

	/**
	 * Get all brands
	 * @returns Promise
	 */
	getAll(): Promise<any> {
		return this.apiService.get(`/brands`)
	}
}
